import { createContext } from 'react'
import useProfile from '../../hooks/useProfile'

export type ProfileContext = ReturnType<typeof useProfile>

const profileContext = createContext<ProfileContext>({} as ProfileContext)

export default profileContext